var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAsActAmbulanceService = function SvgAsActAmbulanceService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as-act-ambulance-service_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "m21.467 11.517-4.392-4.392a1.808 1.808 0 0 0-1.283-.533H14.5V6.25a1.25 1.25 0 0 0-2.5 0v.342H3.817A1.825 1.825 0 0 0 2 8.408v7.275A1.825 1.825 0 0 0 3.817 17.5H4.5a2.5 2.5 0 0 0 5 0h5a2.5 2.5 0 0 0 5 0h.683A1.825 1.825 0 0 0 22 15.683V12.8a1.79 1.79 0 0 0-.533-1.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.667 10.834H12V9.167H9.5v1.667H7.833v2.5H9.5V15H12v-1.666h1.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "as-act-ambulance-service_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 5h20v15H2z"
  })))));
};
export default SvgAsActAmbulanceService;